module.exports = __webpack_public_path__ + "img/loginbgs.0b2a82ae.png";